/**
 * @Author: brand
 * @Date: 2019-06-26 15:04
 * @Email: brandhuang@qq.com
 */
import ax from '../../axios'

/**
 *
 * @param params
 */
export function serviceWorkReportDataAPI (params) {
    return ax({
        url: '/wlapi/index/jobCount',
        method: 'POST',
        params
    })
}
export function serviceQualityReportDataAPI (params) {
    return ax({
        url: '/wlapi/index/jobQuality',
        method: 'POST',
        params
    })
}